import {
    Box,
    Chip,
    Grid,
    LinearProgress,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { common } from '@mui/material/colors';
import { colors } from 'common/constants';
import { ReactComponent as CampaignIcon } from 'assets/images/icons/customer/chiến dịch.svg';
import { ReactComponent as SurveyServiceIcon } from 'assets/images/icons/customer/dịch vụ khảo sát.svg';
import { ReactComponent as DataCollected } from 'assets/images/icons/customer/dữ liệu thu thập.svg';
import { ReactComponent as ServicePackageIcon } from 'assets/images/icons/customer/gói dịch vụ.svg';
import { ReactComponent as IdIcon } from 'assets/images/icons/customer/id.svg';
import { ReactComponent as EmailIcon } from 'assets/images/icons/customer/email.svg';
import { ReactComponent as Payment } from 'assets/images/icons/customer/thanh toán gần đây.svg';
import { ReactComponent as Source } from 'assets/images/icons/customer/nguồn.svg';
import React, { useEffect } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CampaignStatus from 'pages/admin/campaign/components/campaign-status';
import PaymentStatus from 'pages/admin/payment/components/payment-status';
import { createStyleSheet, formatCurrency, handleError } from 'utils/helpers';
import {
    getClientDetail,
    getDataSummaryClient,
    getListCampaignsClient,
    getListPaymentClient,
} from 'services/clientManagement.service';
import { useParams } from 'react-router-dom';
import {
    IResponseCustomer,
    IResponseCustomersCampaigns,
    IResponsePaymentClient,
    IResponseSumaryClient,
} from 'types/customer';
import avatarDefault from 'assets/images/icons/avatar-default.svg';
import dayjs from 'dayjs';

const CustomerDetail: React.FC = () => {
    const [dataCustomer, setCustomer] = React.useState<IResponseCustomer>();
    const [dataCustomerSumary, setDataCustomerSumary] =
        React.useState<IResponseSumaryClient>();
    const [campaigns, setCampaigns] =
        React.useState<IResponseCustomersCampaigns>();
    const [pageCampaigns, setPageCampaigns] = React.useState(1);
    const [payments, setPayments] = React.useState<IResponsePaymentClient>();
    const [pagePayments, setPagePayments] = React.useState(1);
    const id = useParams().id;
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getClientDetail(String(id));
                if (response.success) {
                    setCustomer(response.data);
                }
            } catch (error) {
                handleError(error);
            }
        };
        fetchData();
    }, [id]);

    useEffect(() => {
        const featchDataListCampaigns = async () => {
            try {
                const response = await getListCampaignsClient(String(id), {
                    page: pageCampaigns,
                    limit: 5,
                });
                if (response.success) {
                    const { surveys, current_page, total_page, total_items } =
                        response.data;
                    setCampaigns((prev) => ({
                        surveys: prev ? [...prev.surveys, ...surveys] : surveys,
                        current_page,
                        total_page,
                        total_items,
                    }));
                }
            } catch (error) {
                handleError(error);
            }
        };
        featchDataListCampaigns();
    }, [id, pageCampaigns]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getDataSummaryClient(String(id));
                if (response.success) {
                    setDataCustomerSumary(response.data);
                }
            } catch (error) {
                handleError(error);
            }
        };
        fetchData();
    }, [id]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getListPaymentClient(String(id), {
                    page: 1,
                });
                if (response.success) {
                    const { payments, current_page, total_page, total_items } =
                        response.data;
                    setPayments((prev) => ({
                        payments: prev
                            ? [...prev.payments, ...payments]
                            : payments,
                        current_page,
                        total_page,
                        total_items,
                    }));
                }
            } catch (error) {
                handleError(error);
            }
        };
        fetchData();
    }, [id]);
    return (
        <Box mt={5}>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="end"
                mb={5}
            >
                <Typography
                    variant="h3"
                    component="h3"
                    sx={{
                        fontWeight: '700',
                        fontSize: 28,
                        lineHeight: '33.89px',
                        color: (theme) => theme.palette.primary.main,
                    }}
                >
                    Chi tiết khách hàng
                </Typography>
            </Box>
            <Grid container spacing={4}>
                <Grid item xs={3}>
                    <Box
                        sx={{
                            borderRadius: '15px',
                            height: '100%',
                            overflow: 'auto',
                            backgroundColor: common.white,
                        }}
                    >
                        <Box
                            sx={{
                                padding: 3,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                gap: 2,
                            }}
                        >
                            <Box
                                component={'img'}
                                src={
                                    dataCustomer?.client.attributes.avatar ??
                                    avatarDefault
                                }
                                sx={{
                                    width: 250,
                                    height: 250,
                                    borderRadius: '50%',
                                    border: `4px solid ${colors.main}`,
                                    // backgroundColor: colors.main,
                                }}
                            ></Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: 1,
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: '24px',
                                        fontWeight: 600,
                                        lineHeight: '29.05px',
                                    }}
                                >
                                    {dataCustomer?.client.attributes.username}
                                </Typography>
                                <Chip
                                    label={
                                        dataCustomer?.client.attributes.plan
                                            .name
                                    }
                                    sx={{
                                        backgroundColor:
                                            'var(--color-primary-light-50)',
                                        borderRadius: '5px',
                                        minWidth: '80px',
                                        minHeight: '42px',
                                        fontSize: '14px',
                                        fontWeight: 400,
                                        lineHeight: '16.94px',
                                        color: 'primary.main',
                                    }}
                                />
                            </Box>
                        </Box>
                        <Stack sx={styles.row}>
                            <IdIcon />
                            <Box
                                sx={{
                                    fontWeight: '600',
                                    fontSize: '16px',
                                }}
                            >
                                ID
                            </Box>
                        </Stack>
                        <Stack>
                            <Box
                                sx={{
                                    padding: '17px 35px',
                                    width: '100%',
                                    fontSize: '12px',
                                }}
                            >
                                {`ID-${dataCustomer?.client.attributes.id ?? ''}`}
                            </Box>
                        </Stack>
                        <Stack sx={styles.row}>
                            <EmailIcon />
                            <Box
                                sx={{
                                    fontWeight: '600',
                                    fontSize: '16px',
                                }}
                            >
                                Email
                            </Box>
                        </Stack>
                        <Stack>
                            <Box
                                sx={{
                                    padding: '17px 35px',
                                    width: '100%',
                                    fontSize: '12px',
                                }}
                            >
                                {dataCustomer?.client.attributes.email}
                            </Box>
                        </Stack>
                        <Stack sx={styles.row}>
                            <Payment />
                            <Box
                                sx={{
                                    fontWeight: '600',
                                    fontSize: '16px',
                                }}
                            >
                                Thanh toán gần nhất
                            </Box>
                        </Stack>
                        <Stack>
                            <Box
                                sx={{
                                    padding: '17px 35px',
                                    width: '100%',
                                    fontSize: '12px',
                                }}
                            >
                                {dataCustomer?.client.attributes
                                    .last_payment_at &&
                                    dayjs(
                                        dataCustomer?.client.attributes
                                            .last_payment_at
                                    ).format('DD/MM/YYYY')}
                            </Box>
                        </Stack>
                        <Stack sx={styles.row}>
                            <Source />
                            <Box
                                sx={{
                                    fontWeight: '600',
                                    fontSize: '16px',
                                }}
                            >
                                Nguồn
                            </Box>
                        </Stack>
                        <Stack>
                            <Box
                                sx={{
                                    padding: '17px 35px',
                                    width: '100%',
                                    fontSize: '12px',
                                }}
                            >
                                {dataCustomer?.client.attributes.created_by}
                            </Box>
                        </Stack>
                    </Box>
                </Grid>
                <Grid item xs={9}>
                    <Box
                        sx={{
                            borderRadius: '15px',
                            height: '100%',
                            overflow: 'auto',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: 3,
                                mb: 4,
                            }}
                        >
                            <Box
                                sx={{
                                    flex: 1,
                                    backgroundColor:
                                        'var(--color-primary-light-40)',
                                    borderRadius: '11.67px',
                                    minHeight: '196px',
                                    p: 3,
                                }}
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={2}
                                >
                                    <DataCollected />
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            lineHeight: '19.36px',
                                        }}
                                    >
                                        Dữ liệu thu thập
                                    </Typography>
                                </Stack>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={2}
                                >
                                    Tổng
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            lineHeight: '19.36px',
                                        }}
                                    >
                                        {
                                            dataCustomerSumary?.client
                                                .attributes.data_collection
                                                .total_answer
                                        }
                                    </Typography>
                                </Stack>

                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={2}
                                >
                                    Miễn phí
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            lineHeight: '19.36px',
                                        }}
                                    >
                                        {formatCurrency(
                                            dataCustomerSumary?.client
                                                .attributes.data_collection
                                                .free ?? 0
                                        )}{' '}
                                        VND
                                    </Typography>
                                </Stack>

                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={2}
                                >
                                    Dịch vụ
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            lineHeight: '19.36px',
                                        }}
                                    >
                                        {formatCurrency(
                                            dataCustomerSumary?.client
                                                .attributes.data_collection
                                                .paid ?? 0
                                        )}{' '}
                                        VND
                                    </Typography>
                                </Stack>
                            </Box>
                            <Box
                                sx={{
                                    flex: 1,
                                    backgroundColor: '#FFEEE2',
                                    borderRadius: '11.67px',
                                    minHeight: '196px',
                                    p: 3,
                                }}
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={2}
                                >
                                    <CampaignIcon />
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            lineHeight: '19.36px',
                                        }}
                                    >
                                        Chiến dịch
                                    </Typography>
                                </Stack>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={2}
                                >
                                    Tổng
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            lineHeight: '19.36px',
                                        }}
                                    >
                                        {
                                            dataCustomerSumary?.client
                                                .attributes.campaign
                                                .total_survey
                                        }
                                    </Typography>
                                </Stack>

                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={2}
                                >
                                    Miễn phí
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            lineHeight: '19.36px',
                                        }}
                                    >
                                        {
                                            dataCustomerSumary?.client
                                                .attributes.campaign.free
                                        }
                                    </Typography>
                                </Stack>

                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={2}
                                >
                                    Dịch vụ
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            lineHeight: '19.36px',
                                        }}
                                    >
                                        {
                                            dataCustomerSumary?.client
                                                .attributes.campaign.paid
                                        }
                                    </Typography>
                                </Stack>
                            </Box>
                            <Box
                                sx={{
                                    flex: 1,
                                    backgroundColor: '#EFFBFF',
                                    borderRadius: '11.67px',
                                    minHeight: '196px',
                                    p: 3,
                                }}
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={2}
                                >
                                    <ServicePackageIcon />
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            lineHeight: '19.36px',
                                        }}
                                    >
                                        Gói dịch vụ
                                    </Typography>
                                </Stack>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={2}
                                >
                                    Tổng
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            lineHeight: '19.36px',
                                        }}
                                    >
                                        {
                                            dataCustomerSumary?.client
                                                .attributes.package_service
                                                .total_payment
                                        }
                                    </Typography>
                                </Stack>

                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={2}
                                >
                                    Tổng tiền
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            lineHeight: '19.36px',
                                        }}
                                    >
                                        {formatCurrency(
                                            dataCustomerSumary?.client
                                                .attributes.package_service
                                                .total ?? 0
                                        )}{' '}
                                        VND
                                    </Typography>
                                </Stack>
                            </Box>
                            <Box
                                sx={{
                                    flex: 1,
                                    backgroundColor: '#FFEAED',
                                    borderRadius: '11.67px',
                                    minHeight: '196px',
                                    p: 3,
                                }}
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={2}
                                >
                                    <SurveyServiceIcon />

                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            lineHeight: '19.36px',
                                        }}
                                    >
                                        Dịch vụ khảo sát
                                    </Typography>
                                </Stack>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={2}
                                >
                                    Tổng
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            lineHeight: '19.36px',
                                        }}
                                    >
                                        {
                                            dataCustomerSumary?.client
                                                .attributes.survey_service
                                                .total_payment
                                        }
                                    </Typography>
                                </Stack>

                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    spacing={1}
                                    mb={2}
                                >
                                    Tổng tiền
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 700,
                                            lineHeight: '19.36px',
                                        }}
                                    >
                                        {formatCurrency(
                                            dataCustomerSumary?.client
                                                .attributes.survey_service
                                                .total_price ?? 0
                                        )}{' '}
                                        VND
                                    </Typography>
                                </Stack>
                            </Box>
                        </Box>

                        <Box
                            sx={{
                                p: 3,
                                backgroundColor: common.white,
                                borderRadius: '15px',
                                mb: 4,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: '28px',
                                    lineHeight: '33.89px',
                                    mb: 2,
                                }}
                            >
                                Chiến dịch
                            </Typography>
                            <TableContainer
                                component={Paper}
                                sx={{
                                    boxShadow: 'none',
                                    border: 'none',
                                }}
                            >
                                <Table sx={{ borderCollapse: 'collapse' }}>
                                    <TableHead>
                                        <TableRow>
                                            {[
                                                'ID',
                                                'Chiến dịch',
                                                'Trạng thái',
                                                'Tiến độ thu thập dữ liệu',
                                                'Dữ liệu thu thập',
                                            ].map((cell, index) => (
                                                <TableCell
                                                    key={index}
                                                    align={
                                                        index === 4
                                                            ? 'center'
                                                            : 'left'
                                                    }
                                                    sx={{
                                                        border: 'none',
                                                        fontWeight: 600,
                                                        fontSize: '18px',
                                                        lineHeight: '21.78px',
                                                    }}
                                                >
                                                    {cell}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {campaigns?.surveys?.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    colSpan={5}
                                                    align="center"
                                                    sx={{ border: 'none' }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontSize: '20px',
                                                            fontWeight: 500,
                                                            lineHeight:
                                                                '24.2px',
                                                        }}
                                                    >
                                                        Không có dữ liệu
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                        {campaigns?.surveys?.map(
                                            (item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell
                                                        align="left"
                                                        sx={{ border: 'none' }}
                                                    >
                                                        {item.id}
                                                    </TableCell>
                                                    <TableCell
                                                        align="left"
                                                        sx={{ border: 'none' }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontSize:
                                                                    '18px',
                                                                fontWeight: 500,
                                                                lineHeight:
                                                                    '21.78px',
                                                            }}
                                                        >
                                                            {
                                                                item.attributes
                                                                    .title
                                                            }
                                                        </Typography>{' '}
                                                        {dayjs(
                                                            item.attributes
                                                                .created_at
                                                        ).format('DD/MM/YYYY')}
                                                    </TableCell>
                                                    <TableCell
                                                        align="left"
                                                        sx={{ border: 'none' }}
                                                    >
                                                        <CampaignStatus
                                                            status={
                                                                item.attributes
                                                                    .status_client
                                                            }
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        align="left"
                                                        sx={{ border: 'none' }}
                                                    >
                                                        <LinearProgress
                                                            variant="determinate"
                                                            value={
                                                                item?.attributes
                                                                    ?.data_collection_progress
                                                                    ?.total_answer >
                                                                0
                                                                    ? item
                                                                          .attributes
                                                                          .data_collection_progress
                                                                          .total_answer_free /
                                                                      item
                                                                          .attributes
                                                                          .data_collection_progress
                                                                          .total_answer
                                                                    : 0
                                                            }
                                                            sx={{
                                                                height: 6,
                                                                borderRadius: 10,
                                                                backgroundColor:
                                                                    '#0000001A',
                                                                '& .MuiLinearProgress-bar':
                                                                    {
                                                                        backgroundColor:
                                                                            'primary.main',
                                                                    },
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        sx={{ border: 'none' }}
                                                    >
                                                        <Chip
                                                            label={`${
                                                                item.attributes
                                                                    .data_collection
                                                                    .total_answer_paid
                                                            } /
                                                               ${
                                                                   item
                                                                       .attributes
                                                                       .data_collection
                                                                       .total_answer_paid
                                                               }
                                                            `}
                                                            sx={{
                                                                backgroundColor:
                                                                    'var(--color-primary-light-50)',
                                                                borderRadius:
                                                                    '5px',
                                                                minWidth:
                                                                    '76px',
                                                                minHeight:
                                                                    '42px',
                                                                fontSize:
                                                                    '14px',
                                                                fontWeight: 600,
                                                                lineHeight:
                                                                    '16.94px',
                                                                color: 'primary.main',
                                                            }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {(campaigns?.total_page ?? 0) > pageCampaigns && (
                                <Box
                                    sx={{
                                        textAlign: 'center',
                                    }}
                                >
                                    <Typography
                                        onClick={() =>
                                            setPageCampaigns((prev: number) => {
                                                return prev + 1;
                                            })
                                        }
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            fontSize: '20px',
                                            fontWeight: 500,
                                            lineHeight: '24.2px',
                                            color: 'primary.main',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Xem thêm <ExpandMoreIcon />
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                        <Box
                            sx={{
                                p: 3,
                                backgroundColor: common.white,
                                borderRadius: '15px',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: '28px',
                                    lineHeight: '33.89px',
                                    mb: 2,
                                }}
                            >
                                Thanh toán
                            </Typography>
                            <TableContainer
                                component={Paper}
                                sx={{
                                    boxShadow: 'none',
                                    border: 'none',
                                }}
                            >
                                <Table sx={{ borderCollapse: 'collapse' }}>
                                    <TableHead>
                                        <TableRow>
                                            {[
                                                'ID',
                                                'Thanh toán',
                                                'Nội dung',
                                                'Trạng thái',
                                            ].map((cell, index) => (
                                                <TableCell
                                                    key={index}
                                                    align={
                                                        index === 4
                                                            ? 'center'
                                                            : 'left'
                                                    }
                                                    sx={{
                                                        border: 'none',
                                                        fontWeight: 600,
                                                        fontSize: '18px',
                                                        lineHeight: '21.78px',
                                                    }}
                                                >
                                                    {cell}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {payments?.payments?.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    colSpan={4}
                                                    align="center"
                                                    sx={{ border: 'none' }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontSize: '20px',
                                                            fontWeight: 500,
                                                            lineHeight:
                                                                '24.2px',
                                                        }}
                                                    >
                                                        Không có dữ liệu
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                        {payments?.payments.map(
                                            (item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell
                                                        align="left"
                                                        sx={{ border: 'none' }}
                                                    >
                                                        {item.id}
                                                    </TableCell>
                                                    <TableCell
                                                        align="left"
                                                        sx={{ border: 'none' }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontSize:
                                                                    '18px',
                                                                fontWeight: 500,
                                                                lineHeight:
                                                                    '21.78px',
                                                            }}
                                                        >
                                                            {item.attributes
                                                                .product_type ===
                                                            'Survey'
                                                                ? 'Mua thêm dữ liệu'
                                                                : 'Gói dịch vụ'}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        align="left"
                                                        sx={{ border: 'none' }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontSize:
                                                                    '18px',
                                                                fontWeight: 500,
                                                                lineHeight:
                                                                    '21.78px',
                                                            }}
                                                        >
                                                            {
                                                                item.attributes
                                                                    .product
                                                                    .name
                                                            }
                                                        </Typography>{' '}
                                                        {
                                                            item.attributes
                                                                .product.note
                                                        }
                                                    </TableCell>
                                                    <TableCell
                                                        align="left"
                                                        sx={{ border: 'none' }}
                                                    >
                                                        <PaymentStatus
                                                            status={
                                                                item.attributes
                                                                    .status
                                                            }
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {(payments?.total_page ?? 0) > pagePayments && (
                                <Box
                                    sx={{
                                        textAlign: 'center',
                                    }}
                                >
                                    <Typography
                                        onClick={() =>
                                            setPagePayments((prev: number) => {
                                                return prev + 1;
                                            })
                                        }
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            fontSize: '20px',
                                            fontWeight: 500,
                                            lineHeight: '24.2px',
                                            color: 'primary.main',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Xem thêm <ExpandMoreIcon />
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

const styles = createStyleSheet({
    row: {
        backgroundColor: '#F7F7F6',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '17px 35px',
        gap: 1,
    },
});

export default CustomerDetail;
